import { Box, Button, Text } from '@factorialco/deprecated-design-system'
import { CompetenciesFinderFactorialCompetencyFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

type Props = {
  competency: CompetenciesFinderFactorialCompetencyFragment
  onAdd: () => void
}

export const SuggestionItem = ({ competency, onAdd }: Props) => {
  return (
    <Box
      role="listitem"
      aria-label={competency.name}
      padding="s12"
      flexDirection="row"
      justifyContent="spaceBetween"
      borderRadius={{ all: 'abs016' }}
      border={{
        all: {
          style: 'solid',
          width: 's2',
          color: 'grey400',
        },
      }}
    >
      <Box flexDirection="column" gap="s2">
        <Text.Normal size="300" weight="medium" color="grey1000">
          {competency.name}
        </Text.Normal>
        <Text.Normal size="200" weight="normal" color="grey800">
          {competency.description}
        </Text.Normal>
      </Box>
      <Box flexDirection="row">
        <Button type="secondary" onClick={onAdd}>
          {i18n.t('competencies_v3.competencies_finder.suggestions_add')}
        </Button>
      </Box>
    </Box>
  )
}
